import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { initializeFirestore, getFirestore } from 'firebase/firestore';
import { getMessaging, getToken, isSupported } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID
};


const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

setPersistence(auth, browserLocalPersistence).then(() => {
    console.log('Firebase Auth persistence set to local');
}).catch((error) => {
    console.error('Error setting Firebase Auth persistence:', error);
});

initializeFirestore(app, { experimentalForceLongPolling: true });

export const db = getFirestore(app, import.meta.env.VITE_FIREBASE_DATABASE_ID);

export const messaging = getMessaging(app);

export const isMessagingSupported = async () => {
    return await isSupported();
};


export default app;